function Support() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.31857 14.1429L3.5 17.1429V3.85714C3.5 3.62981 3.59031 3.4118 3.75105 3.25105C3.9118 3.09031 4.12981 3 4.35714 3H17.2143C17.4416 3 17.6596 3.09031 17.8204 3.25105C17.9811 3.4118 18.0714 3.62981 18.0714 3.85714V14.1429H7.31857ZM6.72543 12.4286H16.3571V4.71429H5.21429V13.6157L6.72543 12.4286ZM9.5 15.8571H18.2746L19.7857 17.0443V8.14286H20.6429C20.8702 8.14286 21.0882 8.23316 21.2489 8.39391C21.4097 8.55465 21.5 8.77267 21.5 9V20.5714L17.6814 17.5714H10.3571C10.1298 17.5714 9.9118 17.4811 9.75105 17.3204C9.59031 17.1596 9.5 16.9416 9.5 16.7143V15.8571Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Support;
